import { MOONPAY_API_BASE_URL, MOONPAY_NFT_CLIENT_API_KEY } from "./constants"
import type { MoonPayApiTransaction } from "./types"

type MoonPayApiTransactionsResponse = MoonPayApiTransaction[]

export const fetchMoonPayTransaction = async (id: string) => {
  const response = await fetch(
    `${MOONPAY_API_BASE_URL}/v1/transactions/ext/${id}?apiKey=${MOONPAY_NFT_CLIENT_API_KEY}`,
  )
  if (!response.ok) {
    throw new Error(`Failed to fetch MoonPay transaction: ${id}`)
  }
  const data: MoonPayApiTransactionsResponse = await response.json()
  return data[0]
}
